import React from 'react';

import Layout from 'layouts/Layout';
import OrderFromCsv from './OrderFromCsv';

const OrderFromCsvLayout = () => <Layout component={OrderFromCsv} hasGrid />;

export default OrderFromCsvLayout;
